import React from 'react'
import Header from './Header'
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { useState } from 'react';
import { useDropzone } from 'react-dropzone'
import styled from 'styled-components';
import { confirmAlert } from "react-confirm-alert";
import { useAlert } from "react-alert";
import Report from './Report'
import UpperHeader from './UpperHeader';

export default function ReportPSPM() {
    let alert = useAlert();
    const [proof, setproof] = useState(false);
    const [prooftext, setprooftext] = useState("");
    const [witness, setwitness] = useState(false);
    const [pplwitness, setpplwitness] = useState([]);
    const [files, setFiles] = useState([]);
    const [isSaving, setisSaving] = useState(false);

    const validation = Yup.object().shape({
        anonymous: Yup.boolean().required(""),
        names: Yup.string().when("anonymous", {
            is: false,
            then: (schema) => schema.required(""),
        }),
        p_lastname: Yup.string().when("anonymous", {
            is: false,
            then: (schema) => schema.required(""),
        }),
        m_lastname: Yup.string().when("anonymous", {
            is: false,
            then: (schema) => schema.required(""),
        }),
        street: Yup.string().when("anonymous", {
            is: false,
            then: (schema) => schema.required(""),
        }),
        colony: Yup.string().when("anonymous", {
            is: false,
            then: (schema) => schema.required(""),
        }),
        mpo: Yup.string().when("anonymous", {
            is: false,
            then: (schema) => schema.required(""),
        }),
        cp: Yup.string().when("anonymous", {
            is: false,
            then: (schema) => schema.required(""),
        }),
        phone: Yup.string().required(""),
        email: Yup.string().email('Debe ser un correo valido').required(""),
        ef: Yup.string().required(""),
        name_pspm: Yup.string().required(""),
        data_pspm: Yup.string().required(""),
        place_pspm: Yup.string().required(""),
        date_event: Yup.string().required(""),
        where_event: Yup.string().required(""),
        how_event: Yup.string().required(""),
    });

    const formOptions = { resolver: yupResolver(validation) };

    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        trigger,
        clearErrors
    } = useForm(formOptions);

    async function onSubmit(data) {
        setisSaving(true)
        const formData = new FormData();
        formData.append("report", JSON.stringify({ data, proof, prooftext, witness, pplwitness }));

        files.map((f, i) => {
            formData.append(`reportPSPM-${i}`, f.file[0]);
        });

        fetch(`${process.env.REACT_APP_URL_API}/data/saveReportPSPM`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: formData,
        }).then((response) => response.json())
            .then((datar) => {
                if (datar.rows > 0) {
                    setisSaving(false)
                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <div className="AlertUI">
                                    <h1>Aviso</h1>
                                    <p>
                                        Se ha guardado correctamente tu denuncia
                                    </p>
                                    <button
                                        onClick={() => {
                                            window.location.reload();
                                        }}
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            );
                        },
                    });
                } else {
                    setisSaving(false)
                    alert.show(
                        "Ocurrió un error al guardar los datos, por favor intenta de nuevo",
                        {
                            timeout: 3000,
                            type: "error",
                        }
                    );
                }
            })
            .catch((error) => {
                setisSaving(false)
                alert.show(
                    "Ocurrió un error al guardar los datos, por favor intenta de nuevo " +
                    error,
                    {
                        timeout: 3000,
                        type: "error",
                    }
                );
            });
    }

    const addNewWitness = () => {
        setpplwitness([
            ...pplwitness, {
                name: "",
                data: "",
                phone: "",
            }])
    }

    const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: #0d6efd;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
    `;

    const thumbInner = {
        width: '400px',
        padding: '25px',
        border: "1px #011b6c solid",
        borderRadius: "5px"
    };

    const img = {
        width: '250px',
        height: '200px'
    };

    function StyledDropzone(props) {
        const {
            getRootProps,
            getInputProps,
            isFocused,
            isDragAccept,
            isDragReject
        } = useDropzone({
            accept: { 'image/*': [] }, onDrop: acceptedFiles => {
                setFiles(...files.push({
                    id: 0, file: acceptedFiles.map(file => Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    }))
                }));
            }
        });

        const deleteImage = (index, id) => {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className="AlertUI">
                            <h1>Aviso</h1>
                            <p>
                                ¿Deseas eliminar la imagen?
                            </p>
                            <button onClick={onClose}>No</button>
                            <button
                                onClick={() => {
                                    setFiles(files.filter((item, ind) => (ind !== index)));
                                    onClose()
                                }}
                            >
                                Si
                            </button>
                        </div>
                    );
                },
            });
        }

        const thumbs = files.map((file, index) => (
            <div key={index}>
                <div style={thumbInner} className="ImageBackground">
                    <div className="row text-center">
                        <div className="col-md-12">
                            <img
                                src={file.file[0].preview}
                                style={img}
                                alt='Upper File'
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button type='button' className='btn btn-danger mt-4 form-control' onClick={() => deleteImage(index, file.id)}>Eliminar</button>
                        </div>
                    </div>
                </div>
            </div>
        ));

        return (
            <div className="container">
                <Container {...getRootProps({ isFocused, isDragAccept, isDragReject })}>
                    <input {...getInputProps()} />
                    <p>Arrastra o da clic para subir las imagenes (Una por una)</p>
                </Container>
                <aside className='CalendarContainer pt-4' style={{ justifyContent: "center" }}>
                    {thumbs}
                </aside>
            </div>
        );
    }

    const removeWitness = (index) => {
        var wt = pplwitness.filter((wt, ind) => (ind !== index));
        setpplwitness(wt);
    }

    const handlePeopleWitness = (e, index) => {
        const { name, value } = e.target;
        setpplwitness(
            pplwitness.map((p, i) => (i == index ? { ...p, [name]: value } : p))
        );
    }

    return (
        <div>
            <UpperHeader child={true} />
            <Header />
            <Report child={true} />
            <div className="text-center p-2">
                <p className='colorblue'>
                    <h2 className='fw-bold fst-italic'>
                        Denuncia a <strong>personas servidoras públicas municipales</strong>
                    </h2>
                </p>
                <p>Denuncia actos de corrupción o faltas administrativas de personas servidoras públicas del Municipio de Chihuahua y/o personas físicas o morales privadas vinculados con actos de Gobierno del Municipio, conforme a la ley general de responsabilidades administrativas</p>
                <p>Puedes descargar el formato y llenarlo a mano o bien generar la denuncia en linea</p>
                <div className='text-center pb-2'>
                    <a href='/Denuncia PSPM.pdf' download>
                        <button className="btn btn-primary">Descargar Formato</button>
                    </a>
                </div>
                <h4>Notas</h4>
                <p>1.- En caso de requerir asesoría para el llenado de este formato, favor de comunicarse al teléfono 614 200
                    4800 ext. 6627, de lunes a viernes de 8:30 a 16:00 horas y con gusto le atenderemos, o escribanos a
                    denuncia.oic@mpiochih.gob.mx</p>
                <p>2.- Es muy importante que nos proporciones sus datos y estar en posibilidad de contactarlo a efecto de
                    darle a conocer la situación de la denuncia presentada y en su caso, obtener mayores elementos durante
                    la integración de la investigación.</p>
            </div>
            <img src="../linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "22px" }} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='container pb-5'>
                    <p className='text-justify'>Los datos personales por usted proporcionados serán protegidos en términos del artículo 134 de la Ley de Transparencia y Acceso a la Información Pública del Estado de Chihuahua, así como los datos personales que se recaben en el presente expediente y se registrarán en los controles internos, cuya finalidad es supervisar, controlar y dar seguimiento a la atención que se brinde a las denuncias presentadas, lo anterior con fundamento en los artículos artículos 1, 9 fracc. II y 10 de la Ley General de Responsabilidades Administrativas y 28 fracc. X, 100 fracc. XXX, 101 inciso V, 101 bis inciso VI, del Reglamento Interior del Municipio de Chihuahua.</p>
                    <h5><strong>Datos de la persona servidora pública denunciada y/o particulares vinculados con faltas administrativas graves.</strong></h5>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="">Nombre(s)</label>
                            <input type="text" {...register("name_pspm")} name="name_pspm" className={`form-control ${errors.name_pspm ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Nombre(s) es requerido"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Cargo</label>
                            <input type="text" {...register("data_pspm")} name="data_pspm" className={`form-control ${errors.data_pspm ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Cargo es requerido"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Lugar de Adscripción</label>
                            <input type="text" {...register("place_pspm")} name="place_pspm" className={`form-control ${errors.place_pspm ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Lugar de Adscripción es requerido"}
                            </div>
                        </div>
                    </div>
                    <br />
                    <h5><strong>Narración de los hechos</strong></h5>
                    <div className="row">
                        <div className="col-md-12">
                            <label htmlFor="">¿Cuándo ocurrieron los hechos?</label>
                            <input type="date" {...register("date_event")} name='date_event' className={`form-control ${errors.date_event ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "Este campo es requerido"}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="">¿Dónde ocurrieron los hechos?</label>
                            <textarea {...register("where_event")} name='where_event' className={`form-control ${errors.where_event ? "is-invalid" : ""}`} rows={5} cols={5} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "Este campo es requerido"}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="">¿Cómo ocurrieron los hechos?</label>
                            <textarea {...register("how_event")} name='how_event' className={`form-control ${errors.how_event ? "is-invalid" : ""}`} rows={5} cols={5} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "Este campo es requerido"}
                            </div>
                        </div>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value={proof} onChange={(e) => setproof(e.target.checked)} id="flexCheckDefault" />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                            ¿Existen pruebas de los hechos?
                        </label>
                    </div>
                    <div className={proof ? "row" : "d-none"}>
                        <div className="col-md-12">
                            <label htmlFor="">Precisar</label>
                            <textarea type="text" className='form-control' value={prooftext} onChange={(e) => setprooftext(e.target.value)} rows={5} cols={5} />
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="">Subir evidencia (Si cuenta con ella)</label>
                            <StyledDropzone />
                        </div>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value={witness} onChange={(e) => {
                            setwitness(e.target.checked)
                            setpplwitness([]);
                        }} id="flexCheckDefault" />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                            ¿Tiene testigos de los hechos?
                        </label>
                    </div>
                    <div className={witness ? "" : "d-none"}>
                        <div className="row mt-3 mb-2">
                            <div className="col-md-2">
                                <button className='btn btn-primary' type='button' onClick={() => addNewWitness()}>Agregar nuevo</button>
                            </div>
                        </div>
                        {pplwitness.map((ppl, index) => {
                            return <div className='row' key={index}>
                                <div className="col-md-4">
                                    <label htmlFor="">Nombre(s)</label>
                                    <input type="text" name='name' value={ppl.name} onChange={(e) => {
                                        handlePeopleWitness(e, index)
                                    }} className='form-control' />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="">Domicilio/Correo Electrónico</label>
                                    <input type="text" name='data' value={ppl.data} onChange={(e) => {
                                        handlePeopleWitness(e, index)
                                    }} className='form-control' />
                                </div>
                                <div className="col-md-3">
                                    <label htmlFor="">Teléfono</label>
                                    <input type="text" name='phone' value={ppl.phone} onChange={(e) => {
                                        handlePeopleWitness(e, index)
                                    }} className='form-control' />
                                </div>
                                <div className="col-md-1">
                                    <button type='button' className="btn btn-danger mt-4" onClick={() => {
                                        removeWitness(index)
                                    }}>Quitar</button>
                                </div>
                            </div>
                        })}
                    </div>
                    <div className="form-check" onChange={(e) => {
                        trigger("anonymous");
                        clearErrors()
                    }}>
                        <input className="form-check-input"  {...register("anonymous")} name="anonymous" type="checkbox" value="" id="flexCheckDefault" />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                            ¿Su denuncia es anonima?
                        </label>
                    </div>
                    <h5><strong>Datos de la persona denunciante</strong></h5>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="">Nombre(s)</label>
                            <input type="text" disabled={getValues("anonymous")} {...register("names")} name="names" className={`form-control ${errors.names ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "Los Nombre(s) son requeridos"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Apellido Paterno</label>
                            <input type="text" disabled={getValues("anonymous")} {...register("p_lastname")} name="p_lastname" className={`form-control ${errors.p_lastname ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Apellido Paterno es requerido"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Apellido Materno</label>
                            <input type="text" disabled={getValues("anonymous")} {...register("m_lastname")} name="m_lastname" className={`form-control ${errors.m_lastname ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Apellido Materno es requerido"}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label htmlFor="">Calle</label>
                            <input type="text" disabled={getValues("anonymous")} {...register("street")} name="street" className={`form-control ${errors.street ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "La Calle es requerida"}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="">Colonia</label>
                            <input type="text" disabled={getValues("anonymous")} {...register("colony")} name="colony" className={`form-control ${errors.colony ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "La Colonia es requerida"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Municipio</label>
                            <input type="text" disabled={getValues("anonymous")} {...register("mpo")} name="mpo" className={`form-control ${errors.mpo ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Municipio es requerido"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Código Postal</label>
                            <input type="number" disabled={getValues("anonymous")} {...register("cp")} name="cp" className={`form-control ${errors.cp ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Código Postal es requerido"}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="">Teléfono</label>
                            <input type="text" {...register("phone")} name="phone" className={`form-control ${errors.phone ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Teléfono es requerido"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Correo Electrónico</label>
                            <input type="text" {...register("email")} name="email" className={`form-control ${errors.email ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "El Correo Electrónico debe ser valido"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="">Entidad Federativa</label>
                            <input type="text" {...register("ef")} name="ef" className={`form-control ${errors.ef ? "is-invalid" : ""}`} />
                            <div className="invalid-feedback">
                                {errors === {}
                                    ? ""
                                    : "La Entidad Federativa es requerida"}
                            </div>
                        </div>
                    </div>
                    <button className='btn btn-success mt-4' disabled={isSaving}>Guardar</button>
                </div>
            </form>
        </div>

    )
}
